<template>
    <v-container>

        <v-row justify="center">
            <v-dialog v-model="dialog" width="600px">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Términos y Condiciones</span>
                    </v-card-title>
                    <v-card-text style="text-align: justify;">
                        Al aceptar estos términos, autorizo expresamente a Southbridge Compañía de Seguros Generales
                        S.A. para que trate, almacene, transmita y comunique mis datos personales y la información que
                        he proporcionado voluntariamente, conforme a las finalidades y condiciones que se detallan a
                        continuación:
                        <br><br>
                        <span class="blackLetter">1. Finalidades del Tratamiento de Datos:</span>
                        <br><span class="blackLetter2">Ofrecimiento de Productos y Servicios:</span> Para que
                        Southbridge y las entidades relacionadas me contacten y me proporcionen información y ofertas de
                        sus productos y servicios.
                        <br><span class="blackLetter2">Ejecución del Contrato de Seguro:</span> Para gestionar y cumplir
                        con las obligaciones derivadas del contrato de seguro.
                        <br><span class="blackLetter2">Implementación de Convenios Asociados:</span> Para hacer
                        efectivos los convenios relacionados con los seguros que he contratado.
                        <br><br>
                        <span class="blackLetter">2. Comunicación de Datos a Terceros:</span>
                        <br>-Autorizo la comunicación de mis datos personales a la empresa matriz de Southbridge,
                        sociedades del grupo empresarial al que pertenece y terceros prestadores de servicios, ubicados
                        dentro o fuera de Chile, exclusivamente para las finalidades antes mencionadas.
                        <br>
                        <br>-Southbridge garantiza que dichos terceros cumplirán con las mismas obligaciones de
                        confidencialidad y seguridad en el tratamiento de mis datos personales.
                        <br><br>
                        <span class="blackLetter">3. Derechos del Titular de los Datos:</span>
                        <br>-Tengo derecho a acceder, rectificar, cancelar y oponerme al tratamiento de mis datos
                        personales, conforme a lo establecido en la Ley N° 21.719.
                        <br>
                        <br>-Puedo revocar esta autorización en cualquier momento, lo que no afectará la licitud del
                        tratamiento basado en el consentimiento previo a su retirada.
                        <br><br>
                        <span class="blackLetter">4. Medios de Comunicación:</span>
                        <br>- Acepto que cualquier información, comunicación, declaración o notificación que deba
                        efectuar Southbridge en virtud del presente contrato de seguros sea realizada a través de correo
                        electrónico u otros sistemas de transmisión o registro digital, garantizando la autenticidad e
                        integridad de las comunicaciones.
                        <br><br>
                        <span class="blackLetter">5. Responsabilidad sobre Credenciales de Acceso:</span>
                        <br>-Reconozco que cualquier transacción realizada en el sitio <a
                            href="https://southbridgeseguros.cl/" target="_blank"
                            rel="noopener noreferrer">www.southbridgeseguros.cl</a> con mi RUT y clave personal se
                        entenderá como realizada por mí.
                        <br>
                        <br>-Soy responsable del uso y seguridad de mi clave personal, y exonero a Southbridge de
                        cualquier responsabilidad por el uso indebido de la misma por parte de terceros.
                        <br><br>
                        <span class="blackLetter">6. Veracidad de la Información:</span>
                        <br>-Me comprometo a proporcionar información veraz y actualizada para la contratación del
                        seguro y el uso de las claves o códigos de acceso, liberando a Southbridge de responsabilidad
                        por cualquier mal uso que terceros hagan de la información entregada exclusivamente a mi
                        persona.
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="botonCondiciones" style="color: white;" elevation="0" text
                            @click="dialog = false">
                            Aceptar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <br>

        <Titulo></Titulo>

        <br>
        <br>

        <div v-if="loadingToku == true" class="text-center" style="margin-top:5%">

            <v-progress-circular :size="300" color="primary" indeterminate></v-progress-circular>

            <br>
            <br>

            {{ cont }}

        </div>

        <div v-if="loadingToku == false">

            <br v-if="screen > 800">
            <br v-if="screen > 800">
            <br v-if="screen > 800">
            <br v-if="screen > 800">

            <div v-if="!showTokuIframe" style="max-width: 500px; margin: auto; margin-top: -10%;">

                <h3 class="text-center labelPaso">
                    ¡{{ capitalizeName(userData.name) }}, revisa tus datos!
                </h3>

                <br>

                <h4 class="text-center labelSubpaso">
                    Antes de contratar te mostramos un resumen de tu Seguro Oncológico IRAM
                </h4>

                <v-row>

                    <v-col :class="containBlock">

                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" style="" max-width="100%">
                            <v-card-text class=" font-weight-medium mt-12 text-center text-subtitle-1 color:primary">
                            </v-card-text>
                            <label class="titleResumen">Resumen de tu póliza </label>
                            <hr class="hrline">
                            <v-col style="width: 100%; max-width: 100% !important;">


                                <label class="labelEtiquetaResumen">Contratante: </label>

                                <label class="labelEtiqueta">{{ userData.name }} {{ userData.surname }}</label>

                                <br>

                                <label class="labelEtiquetaResumen">Rut: </label>

                                <label class="labelEtiqueta">{{ userData.rut }}</label>

                                <br>

                                <label class="labelEtiquetaResumen">Teléfono: </label>

                                <label class="labelEtiqueta">{{ userData.phoneNumber }}</label>
                                <br>

                                <label class="labelEtiquetaResumen">Email: </label>

                                <label class="labelEtiqueta">{{ userData.email }}</label>
                                <br>
                                <!-- 
                                <label class="labelEtiquetaResumen">Tipo de Plan: </label>

                                <label class="labelEtiqueta">{{ userData.typePlan }}</label>

                                <br>
                                <br> -->


                                <label class="labelEtiquetaResumen">Declaración de Salud: </label>

                                <label class="labelEtiqueta">Aprobada</label>

                                <br>

                                <label class="labelEtiquetaResumen">Plan: </label>

                                <label class="labelEtiqueta"> UF {{ (planData.plan.price).toFixed(2) }}</label>

                                <br>
                                <br>


                                <div v-if="screen > 800" class="planSubShield">
                                    <img :src=iconSand alt="Protecciones" class="imgSand">
                                    <p class="planSubShieldDetalle">Este seguro tiene un tiempo de espera de activación
                                        <br> de 30 días contínuos desde la fecha de contratación.
                                    </p>
                                </div>

                                <div v-if="screen < 800" class="planSubShieldMobile">
                                    <img :src=iconSand alt="Protecciones" class="imgSand">
                                    <p class="planSubShieldDetalleMobile">Este seguro tiene un tiempo de espera de
                                        activación de 30 días contínuos desde la fecha de contratación.</p>
                                </div>

                                <br>


                            </v-col>
                        </v-card>

                        <!--<div v-if="planData.setDesc" :class="descLabelPrice">
                            <label> Antes <span style="text-decoration: line-through;">{{
                                formatPrice(planData.planOutDesc) }}</span></label>
                        </div> -->

                        <div>
                            <div :class="rectangulo" style="text-align:center; ">
                                <v-row :class="priceContain" style="align-items: center;">
                                    <div :class=labelPrecioPlan>Total a pagar: {{
                                        formatPrice(planData.plan.priceCLP) }} </div>
                                    <div :class=labelPrecioUf>/ UF {{ (planData.plan.price).toFixed(2) }} mensual</div>
                                </v-row>
                            </div>
                            <br>
                            <h3 class="labelFecha">*De acuerdo al valor UF del día {{ fechaActual }}
                            </h3>
                        </div>


                        <!--                         
                        <div v-if="planData.setDesc" class="planOutDesc">
                            <label>Descuento aplicado</label>
                        </div> -->

                        <v-form ref="form" v-model="valid" max-witdh="300px">

                            <v-hover>
                                <v-checkbox :class="vista" :rules="conditionsRules" :color="stepperColor" required>
                                    <template v-slot:label>
                                        <p :class="terminos">Acepto los
                                            <b>
                                                <a style="color:#2D387C" @click="dialog = true">Términos y
                                                    Condiciones de privacidad</a>
                                            </b>
                                        </p>
                                    </template>
                                </v-checkbox>
                            </v-hover>


                        </v-form>

                        <div class="button-container">
                            <v-btn
                                style="background-color: #2D387C; color: white; border-radius: 12px; width: 300px; height: 120%; margin-left: 5%;"
                                :disabled="disabled"
                                @click="validate()">
                                Ir a pagar
                            </v-btn>
                        </div>

                    </v-col>

                </v-row>

            </div>

            <br>
        </div>

    </v-container>
</template>

<script>
import ShieldService from "../services/shield.service.js";
import Titulo from "../components/Titulo.vue";
import iconSand from "../assets/images/time-sand.svg";

// import CryptoJS from 'crypto-js';
import swal from 'sweetalert';

export default {
    data() {
        return {
            showTokuIframe: false,
            terminos: null,
            dialog: false,
            fechaActual: null,
            cont: "Cargando.  ",
            loadingToku: false,
            screen: window.screen.width,
            formatter: new Intl.NumberFormat("es-CL", {
                style: "currency",
                currency: "CLP",
            }),
            stepperColor: '#4F74E3',
            iconSand,
            edadMayor: null,
            insuranceID: null,
            disabled: null,
            userData: {
                name: null,
                surname: null,
                rut: null,
                email: null,
                phoneNumber: null,
                typePlan: null,
            },
            planData: {
            },
            conditionsRules: [
                (v) => !!v || "Debe estar de acuerdo con los términos y condiciones",
            ],
        }
    },
    components: {
        Titulo,
    },
    async mounted() {

        document.body.scrollTop = document.documentElement.scrollTop = 0;

        const query = this.$route.query;
        localStorage.setItem('insuranceID', query.insuranceID);
        this.getInsuranceData(query.insuranceID);

        this.calcularFecha()

        if (this.screen > 800) {
            this.vista = 'test'
            this.rectangulo = 'rectangulo'
            this.priceContain = 'priceContain'
            this.containBlock = 'containBlock'
            this.terminos = 'terminos'
            this.descLabelPrice = 'planOut'
            this.labelPrecioPlan = 'labelPrecioPlan'
            this.labelPrecioUf = 'labelPrecioUf'
        } else {
            this.vista = 'test2'
            this.rectangulo = 'rectangulo2'
            this.priceContain = 'priceContain2'
            this.containBlock = 'containBlock2'
            this.labelPrecioPlan = 'labelPrecioPlan2'
            this.labelPrecioUf = 'labelPrecioUf2'
            this.terminos = 'terminos2'
            this.descLabelPrice = 'planOutMovil'
        }
    },
    methods: {
        async getInsuranceData(insuranceID) {

            this.insuranceID = insuranceID;
            const whatsappResponse = await ShieldService.getInsuranceData(this.insuranceID);

            this.userData = whatsappResponse.data.userData;
            this.planData.plan = whatsappResponse.data.insurance.plan;

            if (whatsappResponse.data.insurance.flagTransactionComplete != 'Pending') {
                this.disabled = true;
                swal({
                    title: "Atención!",
                    text: "Su cotización ya se encuentra procesada.",
                    icon: "info",
                    button: "De acuerdo",
                });
            } else {
                this.disabled = false;
            }

        },
        capitalizeName(name) {
            if (!name) return '';
            return name.charAt(0).toUpperCase() + name.slice(1);
        },
        calcularFecha() {
            let fecha = new Date().toISOString().substr(0, 10).split('-')
            this.fechaActual = fecha[2] + '/' + fecha[1] + '/' + fecha[0]
        },
        formatPrice(number) {
            return this.formatter.format(number);
        },
        async validate() {

            if (this.$refs.form.validate()) {

                this.loadingToku = true;

                try {

                    this.cont = "Estamos Procesando tu Solicitud . . ."

                    const res = await ShieldService.createLinkPayment(
                        this.insuranceID
                    );

                    window.location.href = res

                    this.loadingToku = false;

                } catch (error) {

                    this.loadingToku = false;
                    this.$router.push({ path: '/og/whatsappBusiness/error' })

                }
            }

        },
    }
}
</script>

<style lang="scss">
.toku-frame {
    border: none;
}

.planOut {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    align-items: center;
    text-align: center;
    letter-spacing: -0.02em;
    color: #7474F4;
    margin-left: 38px;
}

.planOutDesc {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    text-align: center;
    letter-spacing: -0.02em;
    color: #7474F4;
    margin-left: 38px;
}

.planOutMovil {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    align-items: center;
    text-align: center;
    letter-spacing: -0.02em;
    color: #7474F4;
    margin-left: 38px;
    margin-top: -7%;
}

.planSubShield {
    background: #F3F3F3;
    border-radius: 4px;
    // width: 578px;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: auto;
    margin-top: 8px;
    width: 80%;
    padding-left: 5%;
}

.planSubShieldMobile {
    background: #F3F3F3;
    border-radius: 4px;
    // width: 578px;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: auto;
    margin-top: 8px;
    width: 80%;
    padding-left: 5%;
}

.planSubShieldDetalle {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    color: #2D387C;
    margin: auto;
    width: 310px;
    line-height: 193.34%;
    margin-top: 5%;
}

.planSubShieldDetalleMobile {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    color: #2D387C;
    margin: auto;
    width: 83%;
    //   line-height: 193.34%;
    margin-top: 5%;
    text-align: justify;
}

.labelFecha {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #232323;
    opacity: 0.75;
    margin: auto;
    text-align: center;
    // margin-left: 40%;
}

.labelPrecioPlan {
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.02em;
    margin-right: 3px;
    color: #FFFF;
}

.labelPrecioUf {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 143.34%;
    letter-spacing: -0.3px;
    color: #FFFF;
    opacity: 0.8;
}

.labelPrecioPlan2 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
    margin-right: 3px;
    color: #FFFF;
}

.labelPrecioUf2 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
    margin-right: 3px;
    color: #FFFF;
}

.botonCondiciones {
    box-sizing: border-box;
    padding: 12px 24px;
    gap: 10px;
    background: #4F74E3;
    border: 2px solid #4F74E3;
    border-radius: 8px;
    margin-top: -6%;
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.02em;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: auto;
}

.labelPaso {
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: -0.01em;
    color: #4F74E3;
    // text-transform: uppercase;
}

.labelSubpaso {
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: -0.01em;
    color: #2D387C;
}

.labelEtiquetaResumen {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 30px;
    letter-spacing: -0.01em;
    color: black;
    padding-left: 4%;
}

.labelEtiqueta {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 25px;
    letter-spacing: -0.01em;
    color: black;
    opacity: 0.75;
}

.terminos {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 143.34%;
    letter-spacing: -0.3px;
    color: #232323;
    opacity: 0.8;
    text-align: justify;
    margin-top: 5%;
}

.terminos2 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 143.34%;
    letter-spacing: -0.3px;
    color: #232323;
    opacity: 0.8;
    text-align: justify;
    margin-top: 5%;
}

.titleResumen {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 30px;
    color: #2D387C;
    text-align: center;
    margin: auto;
    position: relative;
    display: flex;
    justify-content: center;
}

.hrline {
    width: 80%;
    border: 1px solid #E1E1E1;
    margin: auto;
    margin-top: 2%;
}

.test {
    margin-left: 25%;
    margin-top: 1%;
}

.test2 {
    margin-left: 15%;
    margin-top: 2%;
}

.v-alert {
    position: fixed;
    left: 50%;
    bottom: 50px;
    transform: translate(-50%, 100%);
    margin: 0 auto;
}

.rectangulo {
    box-sizing: border-box;
    display: block ruby;
    // position: absolute;
    height: 52px;
    width: 525px;
    border: 2px solid #2D387C1f;
    border-radius: 5px;
    // margin-left: 90px;
    // margin-right: 90px;
    margin-left: 0% !important;
    background: #4F74E3;
    border-radius: 0px 0px 6px 6px;
}

.priceContain {
    display: ruby-base;
    margin-top: 2.5% !important;
}

.priceContain2 {
    display: flex !important;
    justify-content: center;
}

.containBlock {
    max-width: 100% !important;
    width: 100% !important;
    padding: 0 !important;
}

.containBlock2 {
    max-width: 96% !important;
    width: 97% !important;
    padding: 0 !important;
    margin: auto;
}

.linea {
    position: absolute;
    top: 80%;
    transform: translateY(-50%);
    border-top: 2px solid #2D387C1f;
    width: calc(24%);
    height: 0;
    background: #2D387C;
    opacity: 0.15;
}

.lineaIzquierda {
    left: 0;
    width: 122px;
}

.lineaDerecha {
    right: 0;
    width: 120px;
}

.rectangulo2 {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    // position: absolute;
    width: 100%;
    height: 50px;
    // width: 250px;
    border: 2px solid #2D387C1f;
    background-color: #4F74E3;
    border-radius: 0px 0px 5px 5px;
    margin-top: -3%;
    position: relative !important;
    top: 75% !important;
}

.step-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1 {
        font-weight: 500;
        text-align: center;
        color: #464e71;
        margin-bottom: 2rem;
    }

    h2 {
        font-weight: 500;
        color: #464e71;
        margin-bottom: 1rem;
    }

    p {
        text-align: center;
    }

    .back-container {
        width: 100%;
        align-items: flex-start;

        .back-button {


            &:hover {
                opacity: 1;
            }
        }
    }

    .button-container {
        text-align: center;
    }

    .forecast-selector {
        text-transform: uppercase;
        font-weight: 600;
        color: #464e71;
    }
}

.titleLabel {
    display: flex;
    text-align: flex-start;
    margin-bottom: 3%;
    color: #525252
}

.blackLetter {
    color: black;
    font-size: 16px;
}

.blackLetter2 {
    color: black;
    font-size: 15px;
}

.planSubShieldMobile {
    background: #F3F3F3;
    border-radius: 4px;
    // width: 578px;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: auto;
    margin-top: 8px;
    width: 90%;
    padding-left: 5%;
}

.terminos2 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 143.34%;
    letter-spacing: -0.3px;
    color: #232323;
    opacity: 0.8;
    text-align: justify;
    margin-top: 5%;
    width: 80%;
}
</style>
